import React from 'react';

const Card = ({ date, fact }) => {
	return (
		<div className='tc bg-light-coral dib br3 ma2 grow bw2 shadow-5'>
			<img alt='pictures' src='https://source.unsplash.com/user/erondu/1200x500' />
			<div>
			<h2>{date}</h2>
			<h3>{fact}</h3>
			</div>
		</div>
	)
}

export default Card;